import React from 'react'
import { getGameIcon } from '../utils/gameIcons'

// Компонент иконки игры
// props: game (slug строки: cs2 / dota2 / rust), size (px), className
const GameIcon = ({ game, size = 20, className = '' }) => {
  const iconSrc = getGameIcon(game)

  if (!iconSrc) return null

  return (
    <img
      src={iconSrc}
      alt={game}
      width={size}
      height={size}
      className={`rounded object-cover ${className}`}
      loading="lazy"
    />
  )
}

export default GameIcon
